import { SearchMaskGroupType } from 'ltur-state-engine';
var Translations = /** @class */ (function () {
    function Translations() {
    }
    Translations.getLabelKeyForGroupType = function (searchMaskGroupType) {
        switch (searchMaskGroupType) {
            case SearchMaskGroupType.PACKAGE: {
                return "search_mask.package_tab.label";
            }
            case SearchMaskGroupType.HOTEL: {
                return "search_mask.hotel_tab.label";
            }
            case SearchMaskGroupType.FLIGHT: {
                return "search_mask.flight_tab.label";
            }
            case SearchMaskGroupType.RAIL: {
                return "search_mask.rail_tab.label";
            }
            case SearchMaskGroupType.RAIL_PACKAGE: {
                return "search_mask.rail_package_tab.label";
            }
            default: {
                return "search_mask.package_tab.label";
            }
        }
    };
    Translations.getLabelKeyForInputType = function (searchMaskInputType) {
        return "search_mask.input_type." + searchMaskInputType;
    };
    return Translations;
}());
export default Translations;
